import React from 'react';
import BrandPolicyPage from '../PolicyPage/BrandPolicyPage';

const RenterAgreementPage: React.FC = () => <BrandPolicyPage doc="renter-agreement" />;

export default RenterAgreementPage;
